var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyS02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#707590;}.cls-2{isolation:isolate;}.cls-3{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_642",
    "data-name": "Rectangle 642",
    className: "cls-1",
    width: 16,
    height: 16,
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.74,9.67a2.16,2.16,0,0,1-.82,1.8,3.62,3.62,0,0,1-2.28.65,5.46,5.46,0,0,1-2.38-.45V10.34a6.28,6.28,0,0,0,1.24.44,5.57,5.57,0,0,0,1.23.15A2,2,0,0,0,9,10.62a1,1,0,0,0,.39-.85A1.09,1.09,0,0,0,9,9a5.63,5.63,0,0,0-1.5-.79A4,4,0,0,1,5.84,7.08a2.32,2.32,0,0,1-.48-1.47,2,2,0,0,1,.76-1.68,3.16,3.16,0,0,1,2-.62,6,6,0,0,1,2.45.54L10.17,5a5.34,5.34,0,0,0-2-.48,1.54,1.54,0,0,0-1,.3,1,1,0,0,0-.35.78,1,1,0,0,0,.14.57,1.32,1.32,0,0,0,.46.45,7.46,7.46,0,0,0,1.16.56,6,6,0,0,1,1.38.73,2.05,2.05,0,0,1,.65.77A2.38,2.38,0,0,1,10.74,9.67Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyS02);
export default __webpack_public_path__ + "static/media/key_s_02.6e69379c.svg";
export { ForwardRef as ReactComponent };